import React from 'react'
import PropTypes from 'prop-types'

import { FormattedMessage } from 'react-intl'
import styles from './Button.css'

const Button = ({
  className,
  negative,
  label,
  onClick,
  disabled,
  type,
  icon,
  children,
  ...other
}) =>
  <button
    disabled={disabled}
    type={type}
    className={`${negative
      ? styles.negative
      : styles.positive} ${className} ${disabled
        ? styles.inactive
        : styles.active}`}
    onClick={disabled ? undefined : onClick}
    {...other}
  >
    {icon}
    {label ? <FormattedMessage id={label} /> : null}
    {children ? children : null}
  </button>

Button.propTypes = {
  className: PropTypes.string,
  negative: PropTypes.bool,
  label: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool
}

export default Button
